module.exports = __webpack_public_path__ + "static/media/icon-piece6-9.47b51425.png";